<template>
  <div class="container">
    <div class="intro">
      <div class="location">
        <img src="@assets/pc/images/home/location.png" alt="" />
      </div>
      <div class="detail">
        <div class="detail-title">五洲药物国际贸易有限公司</div>
        <div class="detail-title--english">
          Wuzhou Droga Internacional Comércio Limitada
        </div>
        <div class="detail-information">
          <div class="contact">
            <div class="contact-infor">
              <span>+电话:</span>
              <span>澳门：+00853 65885387</span>
            </div>
            <div class="contact-infor">
              <span>+QQ:</span>
              <span>695396498</span>
            </div>
            <div class="contact-infor">
              <span>+微信:</span>
              <span>drugcore</span>
            </div>
            <div class="contact-infor">
              <span>+邮箱:</span>
              <span>service@droga.cn</span>
            </div>
            <div class="contact-infor">
              <span>营业执照:</span>
              <span class="on" @click="modal1 = true">点击查看</span>
            </div>
          </div>
          <div class="weixin-code">
            <img src="@assets/pc/images/home/serve.png" alt="" />
            <span>微信二维码</span>
          </div>
        </div>
        <div class="detail-simple">
          <div class="detail-simple--title">公司简介</div>
          <div class="detail-simple--content">
            五洲药物国际贸易有限公司（Wuzhou Droga Internacional Comércio
            Limitada）是经澳门政府卫生局注册成立的专业药品批发商，致力于国际药品流通批发，国际知名医药品牌代理及销售。自公司创立以来，五洲药物从最初单一的贸易结构逐步转变为现在多元化、规模化、科学化、系统化的新型贸易服务产业。现如今，五洲药物以参比制剂，临床试验药品的进口为主营业务，以品牌与仿制药品、市场短缺药品、紧急医疗需求采购为辅。不断为上下游客户提供品牌、市场、网络、信息等多层面的增值服务，是国内外上百家医药企业不可或缺的重要贸易桥梁。
          </div>
        </div>
      </div>
    </div>
    <Modal v-model="modal1" title="营业执照" @on-ok="modal1 = false">
      <img
        class="code"
        src="http://www.pharmc.cn/file.php?f=201907/f_3580abb3e242ef52460bbf81bdecbd7f&t=jpg&o=&s=&v=1564464093"
        alt=""
      />
    </Modal>
  </div>
</template>

<script>
export default {
  name: "ContactUs",
  data() {
    return {
      modal1: false
    };
  }
};
</script>

<style lang="stylus" scoped>
.container
  .intro
    margin 50px
    display flex
    .location
      width 30px
      height 30px
      margin-top 5px
      img
        width 100%
        height 100%
    .detail
      margin-left 20px
      color #333
      &-title
        font-size 18px
        font-weight 700
        color #444
        &--english
          color #999
          width 420px
          border-bottom 1px solid #ccc
          padding 5px 0 10px
      &-information
        margin-top 15px
        display flex
        .contact
          width 600px
          .contact-infor
            display flex
            color #333
            font-size 15px
            height 30px
            line-height 30px
            span:first-child
              width 75px
            .on
              color #3487e6
              cursor pointer
        .weixin-code
          display flex
          flex-direction column
          margin-top 30px
          img
            width 100px
            height 100px
          span
            text-align center
            margin-top 10px
            color #999
            font-size 14px
      &-simple
        margin-top 50px
        &--title
          font-size 18px
          height 36px
          font-weight 700
          color #444
        &--content
          text-indent 2em
          font-size 15px
          color #999
          width 615px
.code
  width 100%
</style>
